import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ComoParticipar.css';

const FAQ_ITEMS = [
  {
    q: '¿Cómo sé si resulté ganador de un producto o de los puntos?',
    a: 'Una vez completado el 100% de la meta de puntos de un producto, el sorteo oficial se programa 3 días después entre las 22:00 y las 24:00 hrs. Los ganadores se publican inmediatamente en la página oficial del sorteo (/sorteo/:key) para siempre, y el sistema envía una notificación por correo electrónico con todos los detalles.'
  },
  {
    q: '¿Qué es el premio del 10% de los puntos recolectados?',
    a: 'En MatiMarket cada sorteo tiene DOS ganadores independientes: el 1er lugar se lleva el producto físico sellado con envío gratis, y el 2do lugar recibe de inmediato el 10% de la totalidad de puntos acumulados en ese sorteo directamente en su saldo para seguir participando.'
  },
  {
    q: '¿Cómo funciona el envío del producto si resulto ganador?',
    a: 'Coordinamos el despacho a tu dirección ingresada en "Mis Datos". El despacho es 100% gratuito a todo Chile continental con seguimiento en línea y garantía de fábrica del producto.'
  },
  {
    q: '¿Los puntos vencen o caducan?',
    a: 'No. Tus MatiCoins permanecen en tu cuenta de manera indefinida. Puedes acumularlos comprando productos, adquiriendo tickets o recibiendo comisiones automáticas por las compras de tus referidos.'
  },
  {
    q: '¿Cómo se garantiza la transparencia del algoritmo del sorteo?',
    a: 'Cada ticket o aporte genera un folio criptográfico inmutable en la base de datos Supabase con timestamp exacto. El algoritmo público selecciona los números mediante semillas aleatorias verificables y la página del sorteo queda registrada de por vida para consulta pública.'
  }
];

const ComoParticipar = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (idx) => {
    setOpenFaq(openFaq === idx ? null : idx);
  };

  return (
    <div className="como-participar-container">
      {/* HERO SECTION */}
      <div className="cp-hero">
        <div className="cp-hero-badge">
          <span className="material-symbols-outlined text-sm">stars</span>
          <span>Guía Oficial • Sistema Transparente de Sorteos</span>
        </div>

        <h1 className="cp-hero-title">
          ¿Cómo Participar y Ganar en <span className="text-[#b7f900]">MatiMarket</span>?
        </h1>

        <p className="cp-hero-subtitle">
          Acumula MatiCoins, abona tus puntos a productos tecnológicos exclusivos y multiplica tus
          posibilidades: <strong>¡Cada sorteo tiene 2 ganadores oficiales registrados para siempre!</strong>
        </p>

        {/* STATS HIGHLIGHTS RIBBON */}
        <div className="cp-stats-ribbon">
          <div className="cp-stat-item">
            <span className="cp-stat-val text-[#b7f900]">2 Ganadores</span>
            <span className="cp-stat-lbl">Por cada producto sorteado</span>
          </div>
          <div className="cp-stat-divider"></div>
          <div className="cp-stat-item">
            <span className="cp-stat-val text-amber-400">10% Bono Puntos</span>
            <span className="cp-stat-lbl">Para el 2do ganador del pozo</span>
          </div>
          <div className="cp-stat-divider"></div>
          <div className="cp-stat-item">
            <span className="cp-stat-val text-cyan-400">100% Realtime</span>
            <span className="cp-stat-lbl">Auditable en Supabase</span>
          </div>
          <div className="cp-stat-divider"></div>
          <div className="cp-stat-item">
            <span className="cp-stat-val text-purple-400">De por Vida</span>
            <span className="cp-stat-lbl">Comisiones por referidos</span>
          </div>
        </div>
      </div>

      {/* 4 STEPS TIMELINE */}
      <section className="cp-section">
        <div className="cp-section-header">
          <span className="cp-section-tag">EL CAMINO AL PREMIO</span>
          <h2 className="cp-section-title">Tu Guía en 4 Sencillos Pasos</h2>
          <p className="cp-section-desc">
            Participar es rápido, seguro y accesible desde cualquier dispositivo.
          </p>
        </div>

        <div className="cp-steps-grid">
          {/* STEP 1 */}
          <div className="cp-step-card">
            <div className="cp-step-number">01</div>
            <div className="cp-step-icon-box bg-[#b7f900]/15 text-[#b7f900] border-[#b7f900]/30">
              <span className="material-symbols-outlined text-2xl">toll</span>
            </div>
            <h3 className="cp-step-title">Acumula tus MatiCoins</h3>
            <p className="cp-step-text">
              Ganas puntos por cada compra que realices en el Marketplace. También puedes comprar
              packs de tickets directos o invitar a tus amigos con tu enlace de referido para recibir
              puntos vitalicios por todas sus compras.
            </p>
            <div className="cp-step-footer">
              <span className="cp-pill">🎁 Puntos de regalo incluidos</span>
            </div>
          </div>

          {/* STEP 2 */}
          <div className="cp-step-card">
            <div className="cp-step-number">02</div>
            <div className="cp-step-icon-box bg-cyan-500/15 text-cyan-400 border-cyan-500/30">
              <span className="material-symbols-outlined text-2xl">grid_view</span>
            </div>
            <h3 className="cp-step-title">Elige el Producto Deseado</h3>
            <p className="cp-step-text">
              Explora el catálogo con lo último en tecnología, consolas, proyectores, audio y
              herramientas inteligentes. Cada producto tiene su meta de puntos transparente y barra
              de avance en tiempo real.
            </p>
            <div className="cp-step-footer">
              <span className="cp-pill">📊 Meta de puntos visible 24/7</span>
            </div>
          </div>

          {/* STEP 3 */}
          <div className="cp-step-card">
            <div className="cp-step-number">03</div>
            <div className="cp-step-icon-box bg-purple-500/15 text-purple-400 border-purple-500/30">
              <span className="material-symbols-outlined text-2xl">how_to_reg</span>
            </div>
            <h3 className="cp-step-title">Abona tus Puntos al Sorteo</h3>
            <p className="cp-step-text">
              Ingresa al producto y aporta los puntos que desees. Cada punto equivale a una opción
              registrada de manera criptográfica con número de folio, usuario y hora exacta. ¡Entre
              más aportes, mayores tus probabilidades!
            </p>
            <div className="cp-step-footer">
              <span className="cp-pill">🔒 Registro oficial e inmutable</span>
            </div>
          </div>

          {/* STEP 4 */}
          <div className="cp-step-card">
            <div className="cp-step-number">04</div>
            <div className="cp-step-icon-box bg-amber-500/15 text-amber-400 border-amber-500/30">
              <span className="material-symbols-outlined text-2xl">celebration</span>
            </div>
            <h3 className="cp-step-title">Sorteo en Vivo con 2 Ganadores</h3>
            <p className="cp-step-text">
              Al alcanzar el 100% de la meta, el sorteo se ejecuta 3 días después entre las 22:00 y
              24:00 hrs. Nuestro algoritmo certificado selecciona al ganador del producto y al ganador
              del 10% del pozo de puntos.
            </p>
            <div className="cp-step-footer">
              <span className="cp-pill">🏆 Enlace permanente de por vida</span>
            </div>
          </div>
        </div>
      </section>

      {/* DOUBLE WINNER SHOWCASE */}
      <section className="cp-feature-box">
        <div className="cp-feature-content">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/20 text-amber-300 border border-amber-500/40 text-xs font-bold uppercase tracking-wider mb-3">
            <span className="material-symbols-outlined text-sm">workspace_premium</span>
            <span>Sistema Exclusivo de Doble Premio</span>
          </div>

          <h2 className="text-2xl md:text-3xl font-extrabold text-white">
            ¡Doble Oportunidad de Ganar en Cada Sorteo!
          </h2>

          <p className="text-gray-300 text-sm md:text-base max-w-2xl mt-2 mb-6">
            A diferencia de las rifas tradicionales donde solo uno gana, en MatiMarket premiamos
            a dos participantes distintos para que tus opciones sean siempre mucho mayores:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div className="p-4 rounded-xl bg-black/40 border border-[#b7f900]/30 flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#b7f900]/20 text-[#b7f900] flex items-center justify-center flex-shrink-0 font-bold text-lg">
                1°
              </div>
              <div>
                <h4 className="font-bold text-white text-sm">Ganador del Producto Físico</h4>
                <p className="text-xs text-gray-400 mt-1">
                  Se adjudica el producto 100% nuevo, sellado y con despacho asegurado sin costo
                  a cualquier ciudad de Chile.
                </p>
              </div>
            </div>

            <div className="p-4 rounded-xl bg-black/40 border border-amber-500/30 flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-amber-500/20 text-amber-400 flex items-center justify-center flex-shrink-0 font-bold text-lg">
                2°
              </div>
              <div>
                <h4 className="font-bold text-white text-sm">Ganador del 10% en MatiCoins</h4>
                <p className="text-xs text-gray-400 mt-1">
                  Recibe de forma inmediata el 10% del total de puntos recolectados en el sorteo,
                  abonados a su saldo para seguir participando.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO EARN POINTS GRID */}
      <section className="cp-section">
        <div className="cp-section-header">
          <span className="cp-section-tag">FORMAS DE GANAR PUNTOS</span>
          <h2 className="cp-section-title">Múltiples Vías para Sumar MatiCoins</h2>
          <p className="cp-section-desc">
            No necesitas depender de una sola opción: aprovecha todas las dinámicas que MatiMarket tiene para ti.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="cp-earning-card">
            <div className="cp-earning-icon bg-emerald-500/15 text-emerald-400">
              <span className="material-symbols-outlined">shopping_cart_checkout</span>
            </div>
            <h4 className="font-bold text-white text-base mb-1">Compras en Marketplace</h4>
            <p className="text-xs text-gray-400 leading-relaxed mb-4">
              Cada artículo de nuestro catálogo incluye Puntos de Regalo promocionales que se abonan
              a tu billetera digital tras la confirmación de tu pedido.
            </p>
            <Link to="/productos" className="cp-card-btn text-emerald-400 hover:text-emerald-300">
              <span>Ver Catálogo</span>
              <span className="material-symbols-outlined text-sm">arrow_forward</span>
            </Link>
          </div>

          <div className="cp-earning-card">
            <div className="cp-earning-icon bg-[#b7f900]/15 text-[#b7f900]">
              <span className="material-symbols-outlined">confirmation_number</span>
            </div>
            <h4 className="font-bold text-white text-base mb-1">Packs de Tickets</h4>
            <p className="text-xs text-gray-400 leading-relaxed mb-4">
              ¿Quieres participar ya en un sorteo que está a punto de completarse? Adquiere tickets
              directos con precios accesibles desde 5 hasta 100+ puntos.
            </p>
            <Link to="/comprar-tickets" className="cp-card-btn text-[#b7f900] hover:text-[#cbfd33]">
              <span>Comprar Tickets</span>
              <span className="material-symbols-outlined text-sm">arrow_forward</span>
            </Link>
          </div>

          <div className="cp-earning-card">
            <div className="cp-earning-icon bg-amber-500/15 text-amber-400">
              <span className="material-symbols-outlined">groups</span>
            </div>
            <h4 className="font-bold text-white text-base mb-1">Comunidad de Referidos</h4>
            <p className="text-xs text-gray-400 leading-relaxed mb-4">
              Comparte tu enlace personal con amigos. Cada vez que compren productos o tickets,
              tú acumulas puntos automáticos de por vida en tu cuenta.
            </p>
            <Link to="/mis-referidos" className="cp-card-btn text-amber-400 hover:text-amber-300">
              <span>Mi Enlace de Referido</span>
              <span className="material-symbols-outlined text-sm">arrow_forward</span>
            </Link>
          </div>
        </div>
      </section>

      {/* REQUIREMENTS CARD */}
      <section className="cp-section">
        <div className="p-6 md:p-8 rounded-2xl bg-[#11151c] border border-gray-800 text-left">
          <div className="flex items-center gap-3 mb-4">
            <span className="material-symbols-outlined text-cyan-400 text-2xl">verified_user</span>
            <h3 className="text-lg font-bold text-white">Condiciones Generales para Participar</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs text-gray-300">
            <div className="flex items-start gap-2 bg-gray-900/60 p-3.5 rounded-xl border border-gray-800/80">
              <span className="material-symbols-outlined text-emerald-400 text-base">check_circle</span>
              <span><strong>Mayoría de Edad:</strong> Ser mayor de 18 años con residencia en Chile.</span>
            </div>
            <div className="flex items-start gap-2 bg-gray-900/60 p-3.5 rounded-xl border border-gray-800/80">
              <span className="material-symbols-outlined text-emerald-400 text-base">check_circle</span>
              <span><strong>Cuenta Activa:</strong> Estar registrado en MatiMarket con datos de contacto válidos.</span>
            </div>
            <div className="flex items-start gap-2 bg-gray-900/60 p-3.5 rounded-xl border border-gray-800/80">
              <span className="material-symbols-outlined text-emerald-400 text-base">check_circle</span>
              <span><strong>Aporte Mínimo:</strong> Haber abonado al menos 1 punto al producto participante.</span>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ ACCORDION */}
      <section className="cp-section">
        <div className="cp-section-header">
          <span className="cp-section-tag">PREGUNTAS FRECUENTES</span>
          <h2 className="cp-section-title">Resolvemos tus Dudas</h2>
          <p className="cp-section-desc">
            Todo lo que necesitas saber sobre el funcionamiento de los sorteos y la entrega de premios.
          </p>
        </div>

        <div className="cp-faq-list">
          {FAQ_ITEMS.map((item, idx) => {
            const isOpen = openFaq === idx;
            return (
              <div
                key={idx}
                className={`cp-faq-item ${isOpen ? 'open' : ''}`}
                onClick={() => toggleFaq(idx)}
              >
                <div className="cp-faq-question">
                  <span>{item.q}</span>
                  <span className="material-symbols-outlined text-base cp-faq-chevron">
                    {isOpen ? 'expand_less' : 'expand_more'}
                  </span>
                </div>
                {isOpen && (
                  <div className="cp-faq-answer">
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* FINAL ACTION CTA */}
      <section className="cp-cta-banner">
        <div className="cp-cta-glow"></div>
        <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-3">
          ¿Listo para Empezar a Ganar?
        </h2>
        <p className="text-gray-300 text-sm md:text-base max-w-xl mx-auto mb-8">
          Explora los sorteos activos en nuestra plataforma o acumula tus primeros MatiCoins hoy mismo.
        </p>

        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link to="/productos" className="cp-btn-main">
            <span className="material-symbols-outlined text-base">storefront</span>
            <span>Ver Productos & Sorteos</span>
          </Link>
          <Link to="/comprar-tickets" className="cp-btn-secondary">
            <span className="material-symbols-outlined text-base">confirmation_number</span>
            <span>Comprar Tickets</span>
          </Link>
          <Link to="/juegos/el-montoncito" className="cp-btn-secondary border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10">
            <span>🎮 Jugar El Montoncito</span>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ComoParticipar;
